import { links } from "@roman/shared/links";

export const createMarketShareUrl = (marketId: string, host = links.thumbaJp) => {
  // Use URL constructor to properly handle trailing slashes
  const url = new URL(`/prediction-market/details/${marketId}`, host);

  // Add timestamp parameter to clear OGP cache on SNS platforms
  url.searchParams.set("tid", Date.now().toString());

  return url.toString();
};
